export const ERROR_MESSAGES = {
  TOKEN_INVALID: 'Token inválido.',
  TOKEN_EXPIRED: 'Token expirado.',
  TOKEN_USED: 'Token já utilizado.',
  TOKEN_NAME_MISMATCH: 'Token não corresponde a este host.',
  NAME_INVALID: 'Nome de host inválido.',
  NAME_TAKEN: 'Este nome de host já está em uso.',
  VALIDATION_ERROR: 'Dados inválidos.',
  REBIND_CONFLICT: 'O host anterior ainda está enviando. Aguarde ou revogue o registro.',
  ALREADY_REGISTERED: 'Este servidor já está registrado.',
  INVALID_STATE: 'A operação não é permitida neste estado.',
  SYNC_RUNNING: 'Já existe um envio em andamento.',
  HOST_REVOKED: 'O registro foi revogado no servidor de backup.',
  SIGNATURE_INVALID: 'Assinatura da chave inválida.',
  TIMESTAMP_SKEW: 'Relógio do servidor fora da janela aceita.',
  RATE_LIMITED: 'Muitas tentativas. Aguarde um minuto.',
  BACKUP_UNREACHABLE: 'Servidor de backup inacessível.',
  HOSTKEY_MISMATCH: 'A chave do servidor de backup não confere.',
  ENROLL_UNREACHABLE: 'Serviço de matrícula inacessível.',
  LOCK_TIMEOUT: 'Operação de backup ocupada. Tente novamente.',
  NOT_REGISTERED: 'Backup de gravações não configurado neste servidor.',
  INTERNAL: 'Erro interno no backup de gravações.',
};

export const STATE_VIEW = {
  UNREGISTERED: { color: '#e74c3c', label: 'Não configurado', banner: 'Backup não configurado' },
  REGISTERED: { color: '#27ae60', label: 'Registrado', banner: '' },
  CLONE_DETECTED: { color: '#e74c3c', label: 'Cópia detectada', banner: 'Esta máquina é uma cópia: registre com novo nome ou re-vincule' },
  REVOKED: { color: '#e74c3c', label: 'Revogado', banner: 'Registro revogado no servidor de backup' },
};

const HOST_NAME = /^[a-z0-9][a-z0-9-]{2,28}$/;
const TOKEN = /^VGS1-[A-Z2-7]{26}$/;
const SCHEDULE = /^([01]\d|2[0-3]):[0-5]\d$/;
const IPV4 = /^(?:25[0-5]|2[0-4]\d|1?\d?\d)(?:\.(?:25[0-5]|2[0-4]\d|1?\d?\d)){3}$/;
const FQDN = /^(?=.{1,253}$)[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?(\.[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/;
const RESERVED = new Set(['admin', 'root', 'backup', 'test', 'registry', 'tokens', 'legacy']);

export const messageForCode = (code, fallback) => ERROR_MESSAGES[code] || fallback || ERROR_MESSAGES.INTERNAL;

export const stateView = (state) => STATE_VIEW[state] || STATE_VIEW.UNREGISTERED;

export const cloneBanner = (hostName) => (
  hostName
    ? `Esta máquina é uma cópia de ${hostName}: registre com novo nome ou re-vincule`
    : STATE_VIEW.CLONE_DETECTED.banner
);

export const formatBytes = (value) => {
  const size = Number(value);
  if (!Number.isFinite(size) || size < 0) return '0 B';
  if (size < 1024) return `${size} B`;
  const units = ['KB', 'MB', 'GB', 'TB'];
  let current = size / 1024;
  let unit = 0;
  while (current >= 1024 && unit < units.length - 1) {
    current /= 1024;
    unit += 1;
  }
  return `${current.toFixed(current >= 10 ? 0 : 1)} ${units[unit]}`;
};

export const formatAge = (iso, now = Date.now()) => {
  const parsed = Date.parse(iso);
  if (!Number.isFinite(parsed)) return 'nunca';
  const minutes = Math.max(0, Math.round((now - parsed) / 60000));
  if (minutes < 60) return `há ${minutes} min`;
  const hours = Math.round(minutes / 60);
  if (hours < 48) return `há ${hours} h`;
  return `há ${Math.round(hours / 24)} d`;
};

export const diskClass = (pct) => {
  const value = Number(pct);
  if (!Number.isFinite(value) || value < 70) return 'is-success';
  if (value <= 80) return 'is-warning';
  return 'is-danger';
};

export const validateHostName = (value) => {
  if (typeof value !== 'string' || !HOST_NAME.test(value) || value.includes('--') || value.endsWith('-')) {
    return 'Use 3 a 29 caracteres minúsculos, no formato cliente-local-01.';
  }
  if (RESERVED.has(value)) return 'Nome de host reservado.';
  return '';
};

export const validateToken = (value) => (TOKEN.test(value || '') ? '' : 'Token inválido.');

export const validateBackupHost = (value) => (IPV4.test(value || '') || FQDN.test(value || '') ? '' : 'Servidor inválido.');

export const validatePort = (value) => {
  const port = Number(value);
  if (!Number.isInteger(port) || port < 1 || port > 65535) return 'Porta inválida.';
  return '';
};

export const validateSchedule = (value) => (SCHEDULE.test(value || '') ? '' : 'Horário inválido.');

export const validateBwlimit = (value) => {
  const limit = Number(value);
  if (!Number.isInteger(limit) || limit < 0 || limit > 1000000) return 'Limite de banda inválido.';
  return '';
};
